import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import {
  StyledCode,
  StyledCodeContainer,
  StyledCreditItem,
  StyledItemContent,
  StyledItemIcon
} from './style';
import Icon from '../Common/Icon';
import { useTranslation } from 'react-i18next';
import Card from '../Common/Card';
import { useNavigate } from 'react-router';
import DetailsRow from '../Common/DetailsRow';
import { convertToPersian, fixLocaleString } from '../../Utils/common.util';
import useLandingStore from '../../Store/Landing';
import GreenDiscountIcon from '../../Assets/images/discount-green.svg';
import { CreditDataType } from '../../Types/credits.type';
import { StyledCopiedTag } from '../Credits/CreditCard/style';

const SubCredits: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const { data }: { data: CreditDataType } = state || {};

  const { currency } = useLandingStore((state) => state.landingData);

  const [codeIsCopied, setCodeIsCopied] = useState(false);

  useEffect(() => {
    const codeCopyHandler = setTimeout(() => {
      codeIsCopied && setCodeIsCopied(false);
    }, 3000);

    return () => clearTimeout(codeCopyHandler);
  }, [codeIsCopied]);

  return (
    <StyledDiv py={9} px={8}>
      <StyledCodeContainer>
        <StyledDiv
          bg="mainBackground"
          borderRadius="xl"
          width="100%"
          height="50px"
          p="14px"
          display="flex"
          alignItems="center"
          position="relative"
          justifyContent="space-between">
          <StyledDiv display="flex" alignItems="center">
            <Icon
              name="credit_percentage"
              color="secondaryText"
              fontSize={8}
              ml={6}
            />
            <StyledSpan color="normalText" fontSize={4}>
              {t('credits.creditCard.code')}
            </StyledSpan>
          </StyledDiv>
          <StyledCopiedTag codeIsCopied={codeIsCopied} bg="secondaryBackground">
            <Icon name="check" fontSize={10} color="secondaryGreen" ml={6} />
            <StyledSpan color="normalText" fontSize={2}>
              {t('global.copied')}
            </StyledSpan>
          </StyledCopiedTag>
          <StyledCode
            color="primaryBlue"
            cursor="pointer"
            codeIsCopied={codeIsCopied}
            fontSize={4}
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(String(data?.code));
              setCodeIsCopied(true);
            }}>
            <Icon name="duplicate" fontSize={8} color="primaryBlue" mr={6} />
            {data?.code}
          </StyledCode>
        </StyledDiv>
      </StyledCodeContainer>
      <Card>
        {data?.activityListSummaries.map((item) => (
          <StyledCreditItem
            key={item.id}
            onClick={(): void =>
              navigate(`/credit/${item.id}`, { state: { code: data?.code } })
            }>
            <StyledItemIcon>
              <img src={GreenDiscountIcon} alt="discountIcon" />
            </StyledItemIcon>
            <StyledItemContent>
              <DetailsRow
                title={`${t('credits.credit')}:`}
                color={!item.credit ? 'disableBg' : 'secondaryText'}
                value={
                  <StyledSpan
                    fontSize={2}
                    color={!item.credit ? 'disableBg' : 'secondaryGreen'}>
                    {fixLocaleString(item.credit)}
                    <StyledSpan
                      mr={3}
                      fontSize="0.8rem"
                      color={!item.credit ? 'disableBg' : 'minorText'}>
                      {currency}
                    </StyledSpan>
                  </StyledSpan>
                }
              />
              <DetailsRow
                title={`${t('credits.discount')} :`}
                color={!item.percentage ? 'disableBg' : 'secondaryText'}
                value={
                  <StyledSpan
                    color={!item.percentage ? 'disableBg' : 'secondaryGreen'}>
                    {convertToPersian(item.percentage)}
                    <StyledSpan
                      mr={3}
                      fontSize="0.8rem"
                      color={!item.percentage ? 'disableBg' : 'minorText'}>
                      {t('global.percentage')}
                    </StyledSpan>
                  </StyledSpan>
                }
              />
              <DetailsRow
                title={`${t('credits.expireTime')} :`}
                color="secondaryText"
                value={
                  <StyledSpan color="danger" letterSpacing="0.2rem">
                    {item?.creditExpirationDate}
                  </StyledSpan>
                }
              />
            </StyledItemContent>
            <StyledDiv mr={8} ml={4} display="flex" alignItems="center">
              <Icon name="enter-1" color="disableBg" fontSize={4} />
            </StyledDiv>
          </StyledCreditItem>
        ))}
      </Card>
    </StyledDiv>
  );
};

export default SubCredits;
